import { InstanceResponseModel } from '../../../../../apis/v1/instances/model';
import BandwidthCard from './BandwidthCard';
import FirewallRulesCard from './FirewallRulesCard';

interface NetworkingTabPanelProps {
    instance: InstanceResponseModel;
    canManage: boolean;
}

export default function NetworkingTabPanel({ instance, canManage }: NetworkingTabPanelProps) {
    return (
        <div className="w-full flex flex-col gap-4">
            <BandwidthCard bandwidth={instance.bandwidth} />
            <FirewallRulesCard instanceId={instance.id} canManage={canManage} />
        </div>
    );
}
